import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./phone-input.css";
export const Phone = (props: any) => <ReactPhoneInput {...props}/>